import React from 'react'
import { FormProvider, UseFormReturn } from 'react-hook-form'
import { NavigateHeader } from '@/components/atoms/navigate-header'
import { Layout } from '@/components/template/layout'
import { ContentWrapper } from '@/components/template/content-wrapper'
import { Loading } from '@/components/organisms/loading'
import { SurveyFormData } from '@/features/survey/survey-types'

interface SurveyFormTemplateProps {
  title: string
  loading: boolean
  methods: UseFormReturn<{ answers: SurveyFormData }>
  form?: React.ReactNode
  checkoutReservationList?: React.ReactNode, // チェックアウトフローでのみ表示
}

/**
 * アンケートフォーム用のテンプレートコンポーネント
 * FormProviderでフォームコンテキストを提供し、共通レイアウトを適用
 */
export const SurveyFormTemplate: React.FC<SurveyFormTemplateProps> = ({
  title,
  loading,
  methods,
  checkoutReservationList,
  form
}) => {
  return (
    <FormProvider {...methods}>
      <Layout>
        <NavigateHeader title={title} style={{ marginBottom: '1rem' }} />
        <Loading loading={loading}>
          <ContentWrapper>
            {/* チェックアウトフローの場合のみ予約リストを表示 */}
            {checkoutReservationList}
            {form}
          </ContentWrapper>
        </Loading>
      </Layout>
    </FormProvider>
  )
}

